module.exports = __webpack_public_path__ + "media/images/fav/sunstar_favicon-e0980d6da0d5a217c859ccecfa1f9424.ico";